import MetricsIcon from '../../../components/globals/Icons/LensIcons/MetricsIcon.vue'
import PerformanceMetricsIcon from '../../../components/globals/Icons/LensIcons/filters/PerformanceMetricsIcon.vue'
import EngagementMetricsIcon from '../../../components/globals/Icons/LensIcons/filters/EngagementMetricsIcon.vue'
import MediaMetricsIcon from '../../../components/globals/Icons/LensIcons/filters/MediaMetricsIcon.vue'
import ConversionMetricsIcon from '../../../components/globals/Icons/LensIcons/filters/ConversionMetricsIcon.vue'
import MetaMetricsIcon from '../../../components/globals/Icons/LensIcons/MetaMetricsIcon.vue'
import TagIcon from '../../../components/globals/Icons/TagIcon.vue'
import store from '../../../store'
import getFilterTypeOperations from './filterTypeOperations'

const NO_FILTER_METRICS = ['percent_of_purchase_value', 'percent_of_spend']

const getMetricInputPlaceholder = (type) => {
  switch (type) {
    case 'number': return 'Value'
    case 'currency': return 'Amount'
    case 'percent': return 'Rate'
    default: return 'Value'
  }
}

const convertToFilterSchema = (metrics) => {
  return metrics.map(metric => ({
    optionType: 'metric',
    name: metric.name,
    key: metric.key,
    validOperations: getFilterTypeOperations(metric.type),
    input: { type: metric.type, placeholder: getMetricInputPlaceholder(metric.type) }
  }))
}

const getMetricOptions = (metrics, parentGroup, excludedSubsections, includeRelativeTotals) => {
  const groupMetrics = metrics?.[parentGroup]
    ?.filter(metric => !excludedSubsections.includes(metric?.child_group) && !excludedSubsections.includes(metric?.table_group)) ??
    []

  return convertToFilterSchema(groupMetrics).filter(metric => includeRelativeTotals || !NO_FILTER_METRICS.includes(metric.key))
}

const getSubSectionMetricOptions = (metrics, parentGroup, subSection, includeRelativeTotals) => {
  let subSectionMetrics = metrics?.[parentGroup]?.filter(metric => metric?.child_group === subSection) ?? []
  if (!subSectionMetrics.length) {
    subSectionMetrics = metrics?.[parentGroup]?.filter(metric => metric?.table_group === subSection) ?? []
  }

  return convertToFilterSchema(subSectionMetrics).filter(metric => includeRelativeTotals || !NO_FILTER_METRICS.includes(metric.key))
}

const getTagOptions = () => {
  const lensTags = store.getters['LensModule/getLensTags']

  return [
    {
      optionType: 'metadata',
      name: 'Tag',
      key: 'custom_tag',
      input: { type: 'search', placeholder: 'Tag name', searchOptions: lensTags },
      validOperations: getFilterTypeOperations('dropdown')
    }
  ]
}

export default function dynamicFilterOptions (metricGroupsOverride = null, includeRelativeTotals = false) {
  const metricGroups = metricGroupsOverride ?? store.getters['MetricsModule/getMetricGroups']

  const filterCategories = [
    {
      categoryName: 'Foreplay Scores',
      categoryId: 'foreplay_metrics',
      icon: MetricsIcon,
      options: getMetricOptions(metricGroups, 'foreplay_metrics', [], includeRelativeTotals),
      foreplayMetrics: true
    },
    {
      categoryName: 'Performance Metrics',
      categoryId: 'performance',
      icon: PerformanceMetricsIcon,
      options: getMetricOptions(metricGroups, 'performance', [], includeRelativeTotals)
    },
    {
      categoryName: 'Engagement Metrics',
      categoryId: 'engagement',
      icon: EngagementMetricsIcon,
      options: getMetricOptions(metricGroups, 'engagement', [], includeRelativeTotals)
    },
    {
      categoryName: 'Media Metrics',
      categoryId: 'media',
      icon: MediaMetricsIcon,
      options: getMetricOptions(metricGroups, 'media', [], includeRelativeTotals)
    },
    {
      categoryName: 'Conversion Metrics',
      categoryId: 'conversions',
      icon: ConversionMetricsIcon,
      options: getMetricOptions(metricGroups, 'conversions', ['custom_conversions'], includeRelativeTotals)
    },
    {
      categoryName: 'Tags',
      categoryId: 'tags',
      icon: TagIcon,
      options: getTagOptions(),
      isSingleOption: true
    }
  ]

  const customConversions = getSubSectionMetricOptions(metricGroups, 'conversions', 'custom_conversions', includeRelativeTotals)
  if (customConversions?.length) {
    filterCategories.push({
      categoryName: 'Custom Conversions',
      categoryId: 'custom_conversions',
      icon: MetaMetricsIcon,
      options: customConversions
    })
  }

  return filterCategories
}
